module.exports = __webpack_public_path__ + "static/media/piper-setting-social.1bfeab20.svg";